import { render, staticRenderFns } from "./OutlineItem.vue?vue&type=template&id=f1063c20&"
import script from "./OutlineItem.vue?vue&type=script&lang=js&"
export * from "./OutlineItem.vue?vue&type=script&lang=js&"
import style0 from "./OutlineItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports